





















































































































import { Vue, Component } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class About extends Vue {
  dialog = false;

  mounted() {
    this.$store.dispatch('bindApprovedOrganizations');
  }

  get user() {
    return this.$store.state.profileUser;
  }

  get Orgs() {
    const orgFollowing = this.$store.state.approvedOrganizations
      .filter((f: any) => f.uid === this.user.organizations[0]);
    return orgFollowing;
  }
}
